import { EntityName, Page } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Heading } from '@blockanalitica/ui';
import SSREventsTable from './SSREventsTable';
import SSRVolumeChart from './SSRVolumeChart';

export default function SSRActivityPage() {
  return (
    <Page
      title={
        <EntityName
          symbol1={
            <CryptoIcon
              name={'USDS'}
              address={tokensMapping('USDS').address}
              size="4"
            />
          }>
          <Heading size="1">Sky Savings Rate Activity</Heading>
        </EntityName>
      }>
      <SSRVolumeChart />
      <SSREventsTable />
    </Page>
  );
}
